import React from 'react';
import styles from './ProjectMap.module.scss';
import { LocationCard } from './LocationCard/LocationCard';
import { StaticMap } from '../../../../../../../Components/ReportCard/ContactMap/StaticMap/StaticMap';
import { ProjectArea } from '../../../../../../../Models/ProjectValue';
import { UseProjectMap } from './hooks/UseProjectMap';

export interface ProjectMapProps {
  className?: string;
  areas?: ProjectArea[];
}

export const ProjectMap = ({
  className = '',
  areas
}: ProjectMapProps): React.ReactElement<ProjectMapProps> => {
  const { locationText, areasPaths, position, zoom } = UseProjectMap({ areas });
  return (
    <div className={`${styles.projectMap} ${className}`}>
      <div className={styles.mapInfoContainer}>
        <div className={styles.infoWrapper}>
          <LocationCard location={locationText} />
        </div>
      </div>

      <StaticMap areas={areasPaths} position={position} zoom={zoom} />
    </div>
  );
};
